import React from 'react';

import classes from './TimeCounter.module.scss';

const TimeCounter = ({ time }) => {
    const calculateTimeLeft = () => {
        const year = new Date().getFullYear();
        const difference = +new Date(time) - +new Date();
        // const difference = +new Date("2024-07-08T13:13:18Z") - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)).toString().padStart(2, '0'),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24).toString().padStart(2, '0'),
                minutes: Math.floor((difference / 1000 / 60) % 60).toString().padStart(2, '0'),
                seconds: Math.floor((difference / 1000) % 60).toString().padStart(2, '0')
            };
        }
        else
            return null;

        return timeLeft;
    }
    const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeft());
    React.useEffect(() => {
        const id = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => {
            clearTimeout(id);
        };
    });
    return (
        <div className={classes['wrapper']}>
            {time && timeLeft && (
                <div className='d-flex gap-2'>
                    <div className={classes['time-counter']}>
                        <div>
                            {timeLeft.days}
                        </div>
                        <div className={classes['time-label']}>Days</div>
                    </div>
                    <div className={classes['time-counter']}>
                        <div>
                            {timeLeft.hours}
                        </div>
                        <div className={classes['time-label']}>Hours</div>
                    </div>
                    <div className={classes['time-counter']}>
                        <div>
                            {timeLeft.minutes}
                        </div>
                        <div className={classes['time-label']}>Mins</div>
                    </div>
                    <div className={classes['time-counter']}>
                        <div>
                            {timeLeft.seconds}
                        </div>
                        <div className={classes['time-label']}>Secs</div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TimeCounter;
